<template>
  <div class="flex flex-col space-y-4">
    <div @click="handleOpenConfiguration('authenticator-app')" class="w-full select-none flex justify-between px-7 py-6 items-center border border-solid border-gray-200 cursor-pointer hover:bg-gray-100 rounded-md">
      <div class="flex items-center space-x-5">
        <div>
          <div class="w-12 h-12 flex items-center rounded-full justify-center bg-gray-200">
            <i class="fa-solid text-base text-blueGray-800 fa-mobile"></i>
          </div>
        </div>
        <div class="flex flex-col space-y-1.5">
          <div class="flex items-center space-x-3 w-8/12">
            <h5 class="font-poppins  text-blueGray-800 font-semibold">Two Factor Authenticator App</h5>
            <div v-if="getProfile.two_factor_authentication_method === 'authenticator-app'" class="rounded-full text-xs bg-green px-2 py-1 text-white">
              <span>Enable</span>
            </div>
          </div>
          <span class="font-light w-8/12 text-blueGray-600">
            Use an Authenticator App as your two factor authentication (2FA). 
            When you sign in you'll be asked to use the security code provided by your Authenticator App.
          </span>
        </div>
      </div>
      <!-- <button class="flex items-center bg-red-100 border-red-500 px-3 py-2 rounded text-red-500 hover:bg-red-200 border-solid border">
        <span>Remove</span>
      </button> -->
    </div>
    <div class="w-full bg-gray-100 select-none cursor-not-allowed flex justify-between px-7 py-6 items-center border border-solid border-gray-200 hover:bg-gray-100 rounded-md">
      <div class="flex items-center space-x-5">
        <div>
          <div class="w-12 h-12 flex items-center rounded-full justify-center bg-gray-200">
            <i class="fa-solid fa-envelope-open text-base text-blueGray-800"></i>
          </div>
        </div>
        <div class="flex flex-col space-y-1.5">
          <div class="flex items-center space-x-3 w-8/12">
            <h5 class="font-poppins  text-blueGray-800 font-semibold">Email for Two Factor Authentication</h5>
            <div class="rounded-full text-xs bg-blueGray-800 px-2 py-1 text-blueGray-50">
              <span>Coming Soon</span>
            </div>
          </div>
          <h5 class="font-poppins w-8/12 text-blueGray-800 font-semibold"></h5>
          <span class="font-light w-8/12 text-blueGray-600">
            Use the security code send to your email as your two factor authentication (2FA). The security code will be sent to the address associated with this account.
          </span>
        </div>
      </div>
      <!-- <div class="w-4/12">
        <button class="uppercase text-blueGray-800 bg-gray-100 border border-solid border-gray-300 px-4 py-2 rounded">Set up</button>
      </div> -->
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { EventBus } from 'utils/event-bus';
  import { mapGetters } from 'vuex';
  export default Vue.extend({
    methods: {
      handleOpenConfiguration: async function(type) {
        EventBus.$emit('open-configuration-modal', type);
      }
    },
    computed: {
      ...mapGetters(['getProfile']),
    },
    mounted: async function() {
      console.log(this.getProfile);
    }
  });
</script>


// WEBPACK FOOTER //
// SecurityTab.vue?d08b1796